import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import QuestionView from "../views/QuestionView.vue";
import JieGuoView from "../views/JieGuoView.vue";
import BingShiView from "../views/BingShiView.vue";
import MedicalView from "../views/MedicalView.vue";
import CorrectView from "../views/CorrectView.vue";
import ReasonView from "../views/ReasonView.vue";
import ClueView from "../views/ClueView.vue";
import ClueGogoView from "../views/ClueGogoView.vue";
import ClueGoView from "../views/ClueGoView.vue";
import BranchView from "../views/BranchView.vue";
import EffectView from "../views/EffectView.vue";
import ReportView from "../views/ReportView.vue";
import SummaryView from "../views/SummaryView.vue";
import CaseView from "../views/CaseView.vue";
import EndView from "../views/EndView.vue";
import DiagView from "../views/DiagView.vue";
import YanJiuView from "../views/YanJiuView.vue";
import LinChuangView from "../views/LinChuangView.vue";
import BiaoZhunView from "../views/BiaoZhunView.vue";
import JianChaView from "../views/JianChaView.vue";
import TanSuoView from "../views/TanSuoView.vue";
import HuanZheView from "../views/HuanZheView.vue";
import JieTiView from "../views/JieTiView.vue";
import BaoBiaoView from "../views/BaoBiaoView.vue";
import FangAnView from "../views/FangAnView.vue";
import BiJiaoView from "../views/BiJiaoView.vue";
import BiaoMingView from "../views/BiaoMingView.vue";
import GongBuView from "../views/GongBuView.vue";
import BiJiView from "../views/BiJiView.vue";


/*ReportView,SummaryView,CaseView EndView DiagView*/

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },{
    path: "/jieti",
    name: "jieti",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: JieTiView,
  },{
    path: "/biaoming",
    name: "biaoming",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BiaoMingView,
  },{
    path: "/gongbu",
    name: "gongbu",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: GongBuView,
  },{
    path: "/gongbu",
    name: "gongbu",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: GongBuView,
  },{
    path: "/biji",
    name: "biji",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BiJiView,
  },{
    path: "/bijiao",
    name: "bijiao",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BiJiaoView,
  },{
    path: "/fangan",
    name: "fangan",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: FangAnView,
  },  {
    path: "/baobiao",
    name: "baobiao",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BaoBiaoView,
  },
  {
    path: "/tansuo",
    name: "tansuo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: TanSuoView,
  }, {
    path: "/huanzhe",
    name: "huanzhe",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: HuanZheView,
  },

  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: QuestionView,
  },  {
    path: "/jiancha",
    name: "jiancha",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: JianChaView,
  }, {
    path: "/biaozhun",
    name: "biaozhun",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BiaoZhunView,
  },{
    path: "/linchuang",
    name: "linchuang",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: LinChuangView,
  },

  {
    path: "/medica",
    name: "medica",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: MedicalView,
  },

  {
    path: "/correct",
    name: "correct",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: CorrectView,
  },
  {
    path: "/reason",
    name: "reason",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.ClueGogoView.vue
    component: ReasonView,
  },
  {
    path: "/cluego",
    name: "cluego",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ClueGoView,
  },
  {
    path: "/cluegogo",
    name: "cluegogo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ClueGogoView,
  },
  {
    path: "/clue",
    name: "clue",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ClueView,
  },
  {
    path: "/branch",
    name: "branch",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BranchView,
  },
  {
    path: "/effect",
    name: "effect",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: EffectView,
  },
  {
    path: "/end",
    name: "end",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: EndView,
  },

  {
    path: "/report",
    name: "report",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ReportView,
  },
  {
    path: "/summary",
    name: "summary",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: SummaryView,
  },
  {
    path: "/case",
    name: "case",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: CaseView,
  },
  {
    path: "/diag",
    name: "diag",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: DiagView,
  },  {
    path: "/jieguo",
    name: "jieguo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: JieGuoView,
  }, {
    path: "/bingshi",
    name: "bingshi",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BingShiView,
  },{
    path: "/yanjiu",
    name: "yanjiu",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: YanJiuView,
  }
];
/*branch,EffectView,SummaryView,CaseView,DiagView.vue*/

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
